import ControlMode from '.'

// This mode is responsible for spinning the model if there is no
// user interaction, and not spinning the model when there is any
class AttractMode extends ControlMode {
  constructor(...args) {
    super(...args)
    this.tick = this.tick.bind(this)
    // Delay in ms
    this.delay = 3 * 1000
  }

  onActivate() {
    this.requested = Date.now()
    this.spinRate = 0.01
  }

  tick() {
    if (!(this.requested + this.delay <= Date.now())) {
      return
    }
    this.controls.orbitRight((this.controls.orbitIncrement / 2) * this.spinRate)
    if (this.spinRate < 1.0) {
      this.spinRate *= 1.03
    }
  }
}

export default AttractMode
